import './Logo.css';
import classnames from 'classnames';

export interface LogoProps {
  /**
   * Additional CSS class name for the container
   */
  className?: string;
  /**
   * URL or path to the logo image
   */
  logoImage: string;
  /**
   * Alt text for the logo image
   */
  logoAlt: string;
  /**
   * CSS class name for the logo image element
   */
  logoClassName: string;
  /**
   * Separator element to render between logo and app name
   */
  separator: React.ReactNode;
  /**
   * Application name to display next to the logo
   */
  appName: React.ReactNode;
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

export default function Logo({
  className,
  logoImage,
  logoAlt,
  logoClassName,
  separator,
  appName,
  'data-testid': dataTestId,
}: LogoProps) {
  const baseTestId = dataTestId ?? 'logo';

  return (
    <div
      className={classnames('header-logo-container', className)}
      data-testid={baseTestId}>
      <img
        alt={logoAlt}
        className={logoClassName}
        data-testid={`${baseTestId}-image`}
        src={logoImage}
      />
      {separator ? <span data-testid={`${baseTestId}-separator`}>{separator}</span> : null}
      {appName ? <span data-testid={`${baseTestId}-app-name`}>{appName}</span> : null}
    </div>
  );
}
